<template>
  <container>
    <template #content>
      <div class="container">
        <div class="not_found_message">( 404 ) Page Not Found</div>
      </div>
    </template>
  </container>
</template>

<script>
export default {
  name: "NotFound",
  title() {
    return `${this.$route.path} Page Not Found`;
  },
  created() {
    console.log(this.$route.path);
  }
};
</script>

<style scoped>
.not_found_message {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 300px;
  font-size: 2rem;
  color: var(--red-froly);
}
</style>